<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .title
      span Solicitudes por aprobar
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close
    .modal.is-active(key="modal-editar", :class="{'modal-sidebar-desktop-open': showSidebarDesktop }", v-if="modalEditar")
      .modal-background(@click="closeModalEditar")
      .card
        header.modal-card-head.display-flex
          p.flex-1
            span Solicitud de {{ solicitud.nombreEmpleado }}
        .card-content
          .contenedor-datos
            .fechas
              .control
                label Desde
                input.input(type="date", v-model="solicitud.desde", @blur="calcRetorno")
              .control
                label Hasta
                input.input(type="date", v-model="solicitud.hasta", @blur="calcRetorno")
              .control
                label Retorno
                input.input(type="date", v-model="solicitud.retorno", disabled)
              .control.mt-5.email.text-align-center
                label Cuenta con &nbsp;
                  strong {{ diasDisponiblesCambiosSolicitud }}
                  | &nbsp; días disponibles
        footer.card-footer
          a.card-footer-item.is-success(@click="guardarEditarFechas")
            span(v-if="isSaving") Guardando...
            span(v-else) Guardar
          a.card-footer-item( @click="closeModalEditar")
            strong Cancelar
    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionAprobar"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionAprobar = false"
        @do="aprobar"
        ref="confirmarAprobar"
      )
        span(slot="title") ¿Desea aprobar la solicitud?
        span(slot="primaryAction")
          template(v-if="isApproving")
            | Aprobando...
          template(v-else)
            | Aprobar

    transition(
      name='fade',
      tag="div",
      v-if="mostrarConfirmacionRechazar"
      )
      confirmar-accion-overlay(
        @close="mostrarConfirmacionRechazar = false"
        @do="rechazar"
        ref="confirmarRechazar"
      )
        span(slot="title") ¿Desea rechazar la solicitud?
        span(slot="primaryAction")
          template(v-if="isApproving")
            | Rechazando...
          template(v-else)
            | Rechazar
    .body
      table.table.is-striped.is-bordered
        thead
          th Empleado
          th Fecha
          th.hide-break-1 Retorno
          th Reemplazante
          th.hide-break-2 Acciones
        tbody(
          name="table-row"
          is="transition-group"
        )
          tr.row-table(
            v-for="(o, index) in solicitudes"
            :class="{'row-info': o.esDeDelegacion}"
            :key="index+'-tabla'"
          )
            td
              .flex.aic
                span.hint--top.margin-right-5(:aria-label="'Solicitud Delegada'",v-if="o.esDeDelegacion")
                  i.fa.fa-exclamation-circle
                .hint--bottom(:aria-label="'Solicitud: ' + o.id")
                  span.hint--top(:aria-label="'Empleado: ' + o.dniEmpleado") {{ o.nombreEmpleado }}
            td
              .td-wrapper
                .dates-wrapper
                  span {{ o.desde }}
                  template(v-if="o.hasta !== o.desde")
                    span.hide-break-1 &nbsp;-&nbsp;
                    span {{ o.hasta }}
                div.show-break-1.dates-wrapper
                  span.has-text-bold Retorno:
                  span {{ o.retorno }}
                  span.email ({{ o.dias }} días)
            td.hide-break-1
              .td-wrapper
                span {{ o.retorno }}&nbsp;
                span.email ({{ o.dias }} días)
            td
              template(v-if="!o.esSolicitudPasada")
                template(v-if="o.codigoEmpleadoReemplazante")
                  span {{ o.nombreEmpleadoReemplazante }}
                  .icon.quitar
                    i.fa.fa-times(
                      @click="o.codigoEmpleadoReemplazante = null"
                    )
                div.pop-over-container(v-else)
                  loading(v-if="isLoadingReemplazante && index === trIndex")
                  .control.display-flex.align-items-center(v-else)
                    input.input(
                      type="number",
                      v-model="o.codigoEmpleadoReemplazante"
                    )
                    span.icon.cursor-pointer.margin-left-5(@click="o.mostrarBusquedaEmpleado = true")
                      i.fa.fa-search
                  transition(name="fade-quick")
                    .pop-over(
                        v-if="o.mostrarBusquedaEmpleado"
                      )
                        lookup-small-empleado(
                          @selected="seleccionarEmpleadoParaReemplazo(o, $event)"
                          @close="o.mostrarBusquedaEmpleado = false"
                          :codigo="o.codigoEmpleadoReemplazante"
                        )
              .contenedor-acciones.show-break-2(v-if="o.estado === 2 && !o.esSolicitudPasada")
                button.button.is-small(@click="confirmarAprobar(o)")
                  span.icon.is-small
                    i.fa.fa-thumbs-o-up
                  span Aprobar
                button.button.is-small.is-danger(@click="confirmarRechazo(o)")
                  span.icon.is-small
                    i.fa.fa-times
                  span Rechazar
                button.button.is-small(@click="abrirModalEditar(o)")
                  span.icon.is-small
                    i.fa.fa-pencil
                  span Editar fechas
              span.has-text-danger.show-break-2(v-if="o.esSolicitudPasada") Solicitud no aprobada oportunamente, solicitar a RRHH que lo apruebe

            td.hide-break-2
              .contenedor-acciones(v-if="o.estado === 2 && !o.esSolicitudPasada")
                button.button.is-small(@click="confirmarAprobar(o)")
                  span.icon.is-small
                    i.fa.fa-thumbs-o-up
                  span Aprobar
                button.button.is-small.is-danger(@click="confirmarRechazo(o)")
                  span.icon.is-small
                    i.fa.fa-times
                  span Rechazar
                button.button.is-small(@click="abrirModalEditar(o)")
                  span.icon.is-small
                    i.fa.fa-pencil
                  span Editar fechas
              span.has-text-danger(v-if="o.esSolicitudPasada") Solicitud no aprobada oportunamente, solicitar a RRHH que lo apruebe
      loading(v-if="isLoading")
</template>

<script>
import ConfirmarAccionOverlayComponent from './Component_Confirmar_Accion_Overlay'
import LookupSmallEmpleado from './Component_Lookup_Small_Empleado'
import { apiGet, apiPost, apiDelete, notify } from '../util/general'
import { scrollTo } from '../util/scroll'
import moment from 'moment'
export default {
  name: 'lista_solicitud_vacaciones_por_aprobar_component',
  data () {
    return {
      solicitudes: [],
      mostrarConfirmacionAprobar: false,
      mostrarConfirmacionRechazar: false,
      isLoadingReemplazante: false,
      isLoading: false,
      isApproving: false,
      diasCambioSolicitud: 0,
      trIndex: 0,
      solicitud: {},
      modalEditar: false,
      isSaving: false
    }
  },
  components: {
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent,
    LookupSmallEmpleado
  },
  computed: {
    showSidebarDesktop () {
      return this.$store.getters.showSidebarDesktop
    },
    diasDisponiblesCambiosSolicitud () {
      return this.solicitud.diasDisponibles + this.solicitud.dias - this.diasCambioSolicitud
    }
  },
  created () {
    this.fetch()
  },
  methods: {
    calcRetorno () {
      var vm = this
      if (!vm.validarFechas()) return
      var desde = moment(vm.solicitud.desde, 'YYYY-MM-DD')
      var hasta = moment(vm.solicitud.hasta, 'YYYY-MM-DD')
      vm.diasCambioSolicitud = moment(hasta, 'YYYY-MM-DD').diff(moment(desde, 'YYYY-MM-DD'), 'days') + 1
      vm.solicitud.retorno = hasta.add(1, 'days').format('YYYY-MM-DD')
    },
    validarFechas () {
      var vm = this
      if (!vm.solicitud.desde || !vm.solicitud.hasta) {
        notify(vm, 'error', 'Error', 'Debe ingresar las fechas')
        return false
      }
      var desde = moment(vm.solicitud.desde, 'YYYY-MM-DD')
      var hasta = moment(vm.solicitud.hasta, 'YYYY-MM-DD')
      if (desde.isAfter(hasta)) {
        notify(vm, 'error', 'Error', 'La fecha desde no puede ser mayor a la fecha hasta')
        vm.solicitud.hasta = ''
        return false
      }
      return true
    },
    abrirModalEditar (o) {
      this.solicitud = {...o}
      this.solicitud.desde = moment(this.solicitud.desde, 'DD/MM/YYYY').format('YYYY-MM-DD')
      this.solicitud.hasta = moment(this.solicitud.hasta, 'DD/MM/YYYY').format('YYYY-MM-DD')
      this.solicitud.retorno = moment(this.solicitud.retorno, 'DD/MM/YYYY').format('YYYY-MM-DD')
      this.diasCambioSolicitud = this.solicitud.dias
      this.modalEditar = true
    },
    closeModalEditar () {
      this.solicitud = {}
      this.modalEditar = false
    },
    guardarEditarFechas () {
      var vm = this
      if (vm.isSaving) return
      if (!vm.validarFechas()) return
      vm.isSaving = true
      var obj = {
        id: vm.solicitud.id,
        desde: vm.solicitud.desde,
        hasta: vm.solicitud.hasta
      }
      apiPost(vm, '/vacaciones/solicitud/editar-fechas-jefe', obj, function (data) {
        notify(vm, 'success', 'Éxito', data.message)
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSaving = false
        vm.solicitud = {}
        vm.modalEditar = false
      })
    },
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {}
      apiGet(vm, '/vacaciones/jefe/poraprobar', obj, function (data) {
        if (data.lista.length === 0) {
          vm.$emit('close')
        }

        for (let i = 0; i < data.lista.length; i++) {
          let element = data.lista[i];
          element.mostrarBusquedaEmpleado = false
        }
        vm.solicitudes = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    enterEditMode (o) {
      this.solicitudSeleccionada = o
      this.isEditing             = true
    },
    confirmarAprobar (o) {
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionAprobar = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.confirmarAprobar.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    confirmarRechazo (o) {
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionRechazar = true
      this.$nextTick(() => {
        scrollTo({
          ref: this.$refs.confirmarRechazar.$el,
          vm: this,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        })
      })
    },
    aprobar () {
      var vm = this
      if (vm.isApproving) {
        return
      }
      vm.isApproving = true
      var obj = {
        id: vm.solicitudSeleccionada.id
      }
      apiPost(vm, '/vacaciones/solicitud/aprobar', obj, function (data) {
        vm.mostrarConfirmacionAprobar = false
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isApproving = false
      })
    },
    rechazar () {
      var vm = this
      if (vm.isApproving) {
        return
      }
      vm.isApproving = true
      var obj = {
        id: this.solicitudSeleccionada.id
      }

      apiDelete(vm, '/vacaciones/empleado/solicitud', obj, function (data) {
        vm.mostrarConfirmacionRechazar = false
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isApproving = false
      })
    },
    seleccionarEmpleadoParaReemplazo (o, empleado) {
      // Primero guardamos esto
      var vm = this
      vm.isLoadingReemplazante = true
      vm.trIndex = vm.solicitudes.indexOf(o)
      var obj = {
        id: o.id,
        codigoEmpleadoReemplazante: empleado.codigo
      }
      apiPost(vm, '/vacaciones/solicitud/reemplazo', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Se asigno el empleado de reemplazo correctamente')
        o.codigoEmpleadoReemplazante = empleado.codigo
        o.nombreEmpleadoReemplazante = empleado.nombre
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoadingReemplazante = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .text-align-center
    text-align center
  .contenedor-interno
    .close
      float right
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
      .close
        position absolute
        top 3px
        right 3px

  th
    text-align center

  .contenedor-acciones
    display flex
    .button
      flex 1
      margin 0px 5px
      i
        margin-left 2px
        font-size 15px

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important


  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }


  .pop-over
    background: #fff;
    border-radius: 3px;
    border: 1px solid #d6dadc;
    border-bottom-color: #c4c9cc;
    -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
    box-shadow: 0 1px 6px rgba(0,0,0,.15);
    position: absolute;
    width: 300px;
    z-index: 70;
    top 0

  .quitar
    margin-left 5px
    cursor pointer
    i
      font-size 15px
  .email
    font-size 12px
    color #9a9a9a
  td
    .email
      font-size 12px
      color #9a9a9a
  .show-break-1
    display none

  .show-break-2
    display none

  // .hide-break-1
  //   display initial
  .pop-over-container
    position relative

  // @media (max-width 694px)
  //   td
  //     text-align: center
  //     vertical-align: middle
  //     .contenedor-acciones
  //       flex-direction: column
  //       .button
  //         margin-bottom 5px
  //         &:last-child
  //           margin-bottom 0px

  @media (max-width 1088px)
    .table
      font-size 12px
      td
        text-align: center
        vertical-align: middle
      .td-wrapper
        display flex
        justify-content: center
        align-items: center
        flex-direction: column

        .dates-wrapper
          display: flex
          flex-direction: column


    .show-break-1
      display initial

    .hide-break-1
      display none

  @media (max-width 550px)
    .show-break-2
      display initial

    .hide-break-2
      display none

    .contenedor-acciones
      display flex
      flex-direction: column
      gap: 10px
      margin-top 10px

    .pop-over
      right 0px

</style>



// WEBPACK FOOTER //
// Component_Lista_Solicitud_Vacaciones_Por_Aprobar.vue?583592c2